import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/landing-page',
            name: 'Home',
            component: () => import('@/containers/DefaultContainer'),
            meta: { hideInBreadcrumb: true },
            children: [
                {
                    path: 'landing-page',
                    name: 'Beranda',
                    component: () => import('@/views/LandingPage')
                },
                {
                    path: 'engine',
                    redirect: '/engine/dashboard',
                    name: 'Engine',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: "list",
                            name: "Daftar Engine",
                            component: () => import('@/views/engines/Engine')
                        },
                        {
                            path: "dashboard",
                            name: "Dashboard Engine",
                            component: () => import('@/views/engines/Dashboard')
                        },
                        {
                            path: "tipe",
                            name: "Tipe Engine",
                            component: () => import('@/views/engines/EngineType')
                        }
                    ]
                },
                {
                    path: 'elit',
                    name: 'Elektrik',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: "choke",
                            name: "Choke / Gauge",
                            component: () => import('@/views/inventories/Choke')
                        },
                        {
                            path: "controller",
                            name: "Controller",
                            component: () => import('@/views/inventories/Controller')
                        },
                        {
                            path: "downhole-sensor",
                            name: "Downhole Sensor",
                            component: () => import('@/views/inventories/DownholeSensor')
                        },
                        {
                            path: "sinus",
                            name: "Sinus",
                            component: () => import('@/views/inventories/Sinus')
                        },
                        {
                            path: "surface",
                            name: "Surface",
                            component: () => import('@/views/inventories/Surface')
                        },
                        {
                            path: "trafo",
                            name: "Trafo",
                            component: () => import('@/views/inventories/Trafo')
                        },
                        {
                            path: "vsd",
                            name: "VSD",
                            component: () => import('@/views/inventories/VSD')
                        },
                    ]
                },
                {
                    path: 'esp',
                    name: 'ESP',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: "bolt-intake",
                            name: "Bolt Intake",
                            component: () => import('@/views/inventories/BoltIntake')
                        },
                        {
                            path: "gas-separator",
                            name: "Gas Separator",
                            component: () => import('@/views/inventories/GasSeparator')
                        },
                        {
                            path: "gas-handler",
                            name: "Gas Handler",
                            component: () => import('@/views/inventories/GasHandler')
                        },
                        {
                            path: "motor",
                            name: "Motor",
                            component: () => import('@/views/inventories/Motor')
                        },
                        {
                            path: "protector",
                            name: "Protector",
                            component: () => import('@/views/inventories/Protector')
                        },
                        {
                            path: "pump",
                            name: "Pump",
                            component: () => import('@/views/inventories/Pump')
                        },
                        {
                            path: "sand-trapper",
                            name: "Sand Trapper",
                            component: () => import('@/views/inventories/SandTrapper')
                        },
                        {
                            path: "shroud",
                            name: "Shroud",
                            component: () => import('@/views/inventories/Shroud')
                        },
                        {
                            path: "stator",
                            name: "Stator",
                            component: () => import('@/views/inventories/Stator')
                        }
                    ]
                },
                {
                    path: 'plan',
                    name: 'Planner',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/plan/PlanList')
                        },
                        {
                            path: 'create',
                            name: 'Plan Baru',
                            component: () => import('@/views/plan/PlanCreate')
                        },
                        {
                            path: ':id',
                            name: 'Plan Detail',
                            component: () => import('@/views/plan/PlanDetail')
                        }
                    ]
                },
                {
                    path: 'spk',
                    name: 'SPK',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/spk/SpkList')
                        },
                        {
                            path: 'create',
                            name: 'SPK Baru',
                            component: () => import('@/views/spk/SpkCreate')
                        },
                        {
                            path: ':id',
                            name: 'Detail SPK',
                            component: () => import('@/views/spk/SpkDetail')
                        }
                    ]
                },
                {
                    path: 'spk-engine',
                    name: 'SPK Engine',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/spk-engine/SpkEngineList')
                        },
                        {
                            path: 'create',
                            name: 'SPK Engine Baru',
                            component: () => import('@/views/spk-engine/SpkEngineCreate')
                        },
                        {
                            path: ':id',
                            name: 'Detail SPK Engine',
                            component: () => import('@/views/spk-engine/SpkEngineDetail')
                        }
                    ]
                },
                {
                    path: 'logs',
                    name: 'Pencatatan',
                    component: () => import('@/views/logs/Logs')
                },
                {
                    path: 'spk-target',
                    name: 'Target Kerja',
                    component: () => import('@/views/spk-target/SpkTarget')
                },
                {
                    path: 'tiket',
                    name: 'Tiket',
                    component: { render (c) { return c('router-view') } },
                    children: [
                        {
                            path: '',
                            component: () => import('@/views/tickets/TiketMain')
                        },
                        {
                            path: 'create',
                            name: 'Pembuatan Tiket Baru',
                            component: () => import('@/views/tickets/TiketCreate')
                        },
                        {
                            path: ':no',
                            name: 'Detail Tiket',
                            component: () => import('@/views/tickets/TiketDetail')
                        }
                    ]
                },
                {
                    path: 'wilayah',
                    name: 'Wilayah',
                    component: () => import('@/views/locations/Wilayah')
                },
                {
                    path: 'lokasi',
                    name: 'Lokasi',
                    component: () => import('@/views/locations/Lokasi')
                },
                {
                    path: 'manufacturer',
                    name: 'Manufacturer',
                    component: () => import('@/views/manufacturers/Manufacturer')
                },
                {
                    path: 'user',
                    name: 'Users',
                    component: () => import('@/views/users/User')
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/Login')
        }
    ]
}

export default new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})
